import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';
declare var swal: any;
@Injectable()
export class AdminOrSuperAdminGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (!this.authService.isSuperAdminOrAdmin()) {
      swal('Unauthorized Access!!!.', 'You do not have privilege to view this page. ', 'error');
      this.router.navigate(['/auth/login']);
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/admin-or-super-admin-guard.service.ts